import { Slice, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type AttemptSliceStateType = {
    items: any[] | [];
    totalItems: number;
    isTableLoading: boolean;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    sortValue: { field: string; value: "DESC" | "ASC" };
    filterBy: {
        fieldName: string;
        value: string[];
    }[];
    dateFilter: {
        start_date: string | null;
        end_date: string | null;
    };
    isOpenAddDialog: boolean,
    isOpenEditDialog: boolean,
};

const initialState: AttemptSliceStateType = {
    items: [],
    totalItems: 0,
    isTableLoading: true,
    page: 1,
    rowsPerPage: 20,
    searchValue: "",
    sortValue: { field: "createdAt", value: "DESC" },
    filterBy: [
        {
            fieldName: "companyName",
            value: [],
        },
        {
            fieldName: "country",
            value: [],
        },
    ],
    dateFilter: {
        start_date: null,
        end_date: null,
    },
    isOpenAddDialog: false,
    isOpenEditDialog: false,
};

const attemptSlice: Slice<AttemptSliceStateType> = createSlice({
    name: "attemptSlice",
    initialState,
    reducers: {
        setItems: (state, action: PayloadAction<any[] | []>) => {
            state.items = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
            document.getElementById("scroll-top")?.scrollTo(0, 0);
        },
        setRowsPerPage: (state, action: PayloadAction<number>) => {
            state.rowsPerPage = action.payload;
            state.page = 1;
            document.getElementById("scroll-top")?.scrollTo(0, 0);
        },
        setSearchValue: (state, action: PayloadAction<string>) => {
            state.searchValue = action.payload;
            state.page = 1;
        },
        setSortValue: (state, action: PayloadAction<{ field: string; value: "DESC" | "ASC" }>) => {
            state.sortValue = action.payload;
            state.page = 1;
        },
        setTotalItems: (state, action: PayloadAction<number>) => {
            state.totalItems = action.payload;
        },
        setIsTableLoading: (state, action: PayloadAction<boolean>) => {
            state.isTableLoading = action.payload;
        },
        setFilterBy: (state, action: PayloadAction<{ fieldName: string; value: string[] }[]>) => {
            state.filterBy = action.payload;
            state.page = 1;
        },
        setDateFilter: (state, action: PayloadAction<{ start_date: string; end_date: string }>) => {
            state.dateFilter = action.payload;
        },
        setIsOpenAddDialog: (state, action: PayloadAction<boolean>) => {
            state.isOpenAddDialog = action.payload;
        },
        setIsOpenEditDialog: (state, action: PayloadAction<boolean>) => {
            state.isOpenEditDialog = action.payload;
        },
    },
});

export const {
    setItems,
    setPage,
    setRowsPerPage,
    setSearchValue,
    setIsOpenAddDialog,
    setIsOpenEditDialog,
    setSortValue,
    setTotalItems,
    setIsTableLoading,
    setDateFilter,
    setFilterBy,
} = attemptSlice.actions;
export default attemptSlice.reducer;